module.exports = __webpack_public_path__ + "img/_54A6780_t.f5ace2b7.jpg";